import { Box, CardHeader, Divider } from '@mui/material';
import { Gantt, ViewMode } from 'gantt-task-react';
import 'gantt-task-react/dist/index.css';
import { useEffect, useState } from 'react';
import { useSettingsContext } from 'src/components/settings';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { getStartEndDateForProject } from './helper';
import './timeline.css';
import { ViewSwitcher } from './vewSwitcher';

const TaskListTable = ({ tasks, rowWidth, rowHeight, onExpanderClick }) => {
  return (
    <div style={ { border: '1px solid #dfe1e5' } }>
      { tasks?.map((item, i) => {
        const isProject = item.type === 'project';
        return (
          <div
            key={ item.id }
            style={ {
              height: rowHeight,
              width: rowWidth,
              display: 'flex',
              overflow: 'hidden',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: isProject ? 'pointer' : 'auto',
              fontFamily: 'sans-serif',
              background: i % 2 === 0 ? '#ffffff' : '#f4f5f7',
              padding: 10,
              paddingLeft: isProject ? 10 : 40,
            } }
          >
            <p
              onClick={ () => onExpanderClick(item) }
              style={ {
                display: 'flex',
                alignItems: 'center',
                margin: 0,
                // color: 'transparent',
              } }
            >
              { item.name }
            </p>
          </div>
        );
      }) }
    </div>
  );
};

const Timeline2 = () => {
  const settings = useSettingsContext();

  const [ view, setView ] = useState(ViewMode.Day);
  const [ tasks, setTasks ] = useState([]);
  const [ isChecked, setIsChecked ] = useState(true);

  const getTasks = async () => {
    try {
      const data = await getRequest(
        endpoints.admin_dashboard.marketing_management.timeline.get_cards
      );
      const transformData = data.map((item, index) => ({
        id: String(index + 1),
        name: item.title,
        start: new Date(item?.start_date || new Date()),
        end: new Date(item.due_date),
        type: 'task',
        progress: 0,
        styles: {
          progressColor: '#7A5AF8',
          backgroundColor: '#C084FC',
        },
      }));

      setTasks(transformData);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getTasks();
  }, []);

  let columnWidth = 105;
  if (view === ViewMode.Year) {
    columnWidth = 350;
  } else if (view === ViewMode.Month) {
    columnWidth = 300;
  } else if (view === ViewMode.Week) {
    columnWidth = 250;
  }

  const handleTaskChange = (task) => {
    console.log('On date change Id:' + task.id);
    let newTasks = tasks.map((t) => (t.id === task.id ? task : t));
    if (task.project) {
      const [ start, end ] = getStartEndDateForProject(newTasks, task.project);
      const project = newTasks.find((t) => t.id === task.project);
      if (project.start.getTime() !== start.getTime() || project.end.getTime() !== end.getTime()) {
        const changedProject = { ...project, start, end };
        newTasks = newTasks.map((t) => (t.id === task.project ? changedProject : t));
      }
    }
    setTasks(newTasks);
  };

  const handleTaskDelete = (task) => {
    const conf = window.confirm('Are you sure about ' + task.name + ' ?');
    if (conf) {
      setTasks(tasks.filter((t) => t.id !== task.id));
    }
    return conf;
  };

  const handleProgressChange = async (task) => {
    setTasks(tasks.map((t) => (t.id === task.id ? task : t)));
    console.log('On progress change Id:' + task.id);
  };

  const handleDblClick = (task) => {
    alert('On Double Click event Id:' + task.id);
  };

  const handleClick = (task) => {
    console.log('On Click event Id:' + task.id);
  };

  const handleSelect = (task, isSelected) => {
    console.log(task.name + ' has ' + (isSelected ? 'selected' : 'unselected'));
  };

  const handleExpanderClick = (task) => {
    setTasks(tasks.map((t) => (t.id === task.id ? task : t)));
    console.log('On expander click Id:' + task.id);
  };

  const handleAddTask = (task) => {
    const currentDate = new Date();

    const newTask = {
      name: 'new task',
      type: 'task',
      progress: 100,
      id: new Date().getMilliseconds().toString(),
      start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2),
      end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 4, 0, 0),
      project: task.id,
    };
    setTasks((prevTasks) => [ ...prevTasks, newTask ]);
  };

  return (
    <>

      { tasks.length > 0 && (
        <>
          <CardHeader
            title="Time Line"
            sx={ {
              fontWeight: 'bold',
              fontSize: '1.5rem',
              color: '#333',
              pb: 1,
            } }
          />

          <Divider sx={ { mb: 2 } } />
          <Gantt
            tasks={ tasks }
            viewMode={ view }
            onDateChange={ handleTaskChange }
            onDelete={ handleTaskDelete }
            onProgressChange={ handleProgressChange }
            onDoubleClick={ handleDblClick }
            onClick={ handleClick }
            onSelect={ handleSelect }
            onExpanderClick={ handleExpanderClick }
            listCellWidth={ isChecked ? '295px' : '' }
            columnWidth={ columnWidth }
            rowHeight={ 40 }
            todayColor="rgba(246, 246, 247, .6)"
            timeStep={ 100 }
            TaskListHeader={ ({ headerHeight }) => (
              <Box
                sx={ {
                  height: headerHeight,
                  fontFamily: 'sans-serif',
                  fontWeight: 'bold',
                  px: 2,
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#fafafa',
                  borderBottom: '1px solid #e0e0e0',
                } }
              >
                Name
              </Box>
            ) }
            TaskListTable={ (props) => (
              <TaskListTable
                { ...props }
                handleAddTask={ handleAddTask }
                showTaskNames={ false } // Pass this prop
              />
            ) }
          />

          <Divider sx={ { mt: 2 } } />
          <Box sx={ { display: 'flex', justifyContent: 'flex-end', mt: 2 } }>
            <ViewSwitcher
              onViewModeChange={ (viewMode) => setView(viewMode) }
              onViewListChange={ setIsChecked }
              isChecked={ isChecked }
            />
          </Box>
        </>
      ) }
      {/* </Card > */ }
    </>
  );
};
export default Timeline2;